export default "__VITE_ASSET__d7fb84f9__"